module.exports = __webpack_public_path__ + "img/eagle.719cfdcc.svg";